import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setLookOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {zoomCanvasOut} from "../lookFunctions";
import {setCanvasScale} from "../../../../actions/actionFunctions";
import LookCanvasContext from "../../lookCanvasContext";

const LookMainHeaderCloseButton = (props) => {

  const {intl, history, setLookOpened, setCanvasScale} = props;

  const closeButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuHeaderClose);
    setLookOpened(false);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(ROUTES.home);
  };

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                    className="look-icon look-icon--small look-icon--white"
                    onClick={() => closeButtonClick(imageCanvas)}>
          <CloseIcon/>
        </IconButton>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setCanvasScale,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookMainHeaderCloseButton)
  )
)
